import { Dayjs } from "dayjs";
import {
  HeatSummary,
  LocationExceptionalStatusRead,
  ReviewPeriodData,
  ReviewTimelineTick,
  SegmentStatusListItem,
} from "src/store/api/generatedApi";
import { EventMarkers } from "./EventMarkers";
import { ExceptionalStatusMarkers } from "./ExceptionalStatusMarkers";
import { HeatMarkers } from "./HeatMarkers";
import { LoadingInterval } from "./locationLoadingIntervals";
import { LocationLoadingStrip } from "./LocationLoadingStrip";
import { ReviewPeriodMarkers } from "./ReviewPeriodMarkers";
import { SegmentCoverageMarkers } from "./SegmentCoverageMarkers";
import { EXPANDED_LANE } from "./timelineLayout";

interface ExpandedLocationLaneProps {
  heats: HeatSummary[];
  ticks: ReviewTimelineTick[];
  reviewPeriods: ReviewPeriodData[];
  exceptionalStatuses: LocationExceptionalStatusRead[];
  loadingIntervals?: readonly LoadingInterval[];
  segmentCoverageItems?: readonly SegmentStatusListItem[];
  segmentLengthSec?: number;
  emphasizeSparseSegments?: boolean;
  dayStart: Dayjs;
  getPositionPercent: (time: Dayjs) => number;
}

export const ExpandedLocationLane = ({
  heats,
  ticks,
  reviewPeriods,
  exceptionalStatuses,
  loadingIntervals,
  segmentCoverageItems,
  segmentLengthSec,
  emphasizeSparseSegments,
  dayStart,
  getPositionPercent,
}: ExpandedLocationLaneProps) => (
  <>
    <ReviewPeriodMarkers
      reviewPeriods={reviewPeriods}
      slot={EXPANDED_LANE.reviewPeriods}
      getPositionPercent={getPositionPercent}
    />
    {segmentCoverageItems && segmentLengthSec ? (
      <SegmentCoverageMarkers
        items={segmentCoverageItems}
        dayStart={dayStart}
        segmentLengthSec={segmentLengthSec}
        slot={EXPANDED_LANE.segmentCoverage}
        emphasizeSparseSegments={emphasizeSparseSegments}
      />
    ) : null}
    <HeatMarkers
      heats={heats}
      slot={EXPANDED_LANE.heats}
      getPositionPercent={getPositionPercent}
    />
    <EventMarkers
      ticks={ticks}
      slot={EXPANDED_LANE.events}
      getPositionPercent={getPositionPercent}
    />
    <ExceptionalStatusMarkers
      exceptionalStatuses={exceptionalStatuses}
      slot={EXPANDED_LANE.exceptionalStatuses}
      getPositionPercent={getPositionPercent}
    />
    {loadingIntervals ? (
      <LocationLoadingStrip
        intervals={loadingIntervals}
        slot={EXPANDED_LANE.loading}
        getPositionPercent={getPositionPercent}
      />
    ) : null}
  </>
);
